<app-user-plus
  *ngIf="isHabilitarAddAvalista"
  class="user-enabled"
  (onClick)="abrirInclusaoAvalista()"
></app-user-plus>

<app-avalista
  [fichaCadastro]="fichaCadastro"
  [idFicha]="idFicha"
  [cpfCliente]="proposta.cliente?.cpf"
  [isPj]="proposta?.proposta?.cliente?.categoria === 'J'"
></app-avalista>
